"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const Styled = __importStar(require("./TitleBar.styled"));
const TitleBar = ({ title, onClickBack }) => ((0, jsx_runtime_1.jsxs)(Styled.TitleBar, { children: [(0, jsx_runtime_1.jsx)(Styled.IconButton, Object.assign({ as: "button", "autotagging-flora": "on", "aria-label": "voltar", label: "voltar", "data-flora": "button", "data-flora-text": "voltar", onClick: onClickBack }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.ArrowLeftIcon, {}) })), (0, jsx_runtime_1.jsx)(flora_react_1.Heading, Object.assign({ color: "$backgroundAltPrimary", level: 6 }, { children: title }))] }));
TitleBar.defaultProps = {
    onClickBack: () => null,
};
exports.default = TitleBar;
